Drupal.behaviors.toybox_breadcrumb = {
  // eslint-disable-next-line no-unused-vars
  attach: function (context, settings) {
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!window.buplDisableAnimations) {
      return;
    }

    // Adding a timeout, so it's animated on load.
    setTimeout(function () {
      var scrolls = context.querySelectorAll(
        ".js-breadcrumb-scroll:not(.is-initialized)",
      );

      scrolls.forEach(function (scroll) {
        scroll.classList.add("is-initialized");

        scroll.scrollLeft = scroll.scrollWidth;
      });
    }, 500);
  },
};
